import Axios from "./Axios";
import ENDPOINTS from "./endpoints";

export interface IOrderDetail {
  orderDetailId?: number;
  productId?: number;
  productName?: string;
  productDesc?: string;
  productPrice?: number;
  productQty?: number;
  productImgUrl?: string;
  orderDetailStatus?: string | number;
  [key: string]: any;
}

export interface IOrder {
  orderId: number;
  orderNumber?: string;
  orderDate?: string;
  userId?: number;
  userFName?: string;
  userName?: string;
  userEmail?: string;
  orderTotalPrice?: number;
  userAdd?: string;
  orderStatus?: string;
  orderDetails?: IOrderDetail[];
  [key: string]: any;
}

export const ORDER_STATUS_OPTIONS: Array<{ value: number; label: string }> = [
  { value: 1, label: "Confirmed" },
  { value: 2, label: "Processing" },
  { value: 3, label: "Shipped" },
  { value: 4, label: "Delivered" },
  { value: 5, label: "Returned" },
  { value: 6, label: "Cancelled" },
  { value: 7, label: "Pending" },
  { value: 8, label: "Partial Delivered" },
  { value: 9, label: "Payment Failed" },
];

const getUserOrders = (userId: number) => {
  return Axios.get<any>(ENDPOINTS.orders.byUser(userId));
};

const getAllOrders = () => {
  return Axios.get<any>(ENDPOINTS.orders.all);
};

type OrderFilterParams = {
  page?: number;
  size?: number;
  orderStatusId?: number | string;
  [key: string]: any;
};

const filterOrders = (params: OrderFilterParams = {}) => {

  const {
    page = 0,
    size = 20,
    soryBy = "order",
    sortDirection = "Desc",
    ...rest
  } = params;
  return Axios.get<any>(ENDPOINTS.orders.filter, {
    params: { page, size, soryBy, sortDirection, ...rest },
  });
};

const getOrderById = (orderId: number) => {
  return Axios.get<any>(ENDPOINTS.orders.byId(orderId));
};

export interface ICreateOrderDetail {
  productId: number;
  productQty: number;
  skuId?: number;
}

export interface ICreateOrderPayload {
  description?: string;
  orderDate: [number, number, number, number, number];
  userId: number;
  orderStatus: number;
  shipmentDate?: null;
  userName?: string | null;
  userEmail?: string | null;
  userPhone?: string | null;
  userCity?: string;
  userAdd?: string;
  userCo?: string;
  userFName?: string | null;
  userMName?: string | null;
  userLName?: string | null;
  userMobile?: string | null;
  currency?: string;
  shippingMode?: string;
  customerId: number;
  orderOrigin?: number;
  orderDetails: ICreateOrderDetail[];
}

const createOrder = (payload: ICreateOrderPayload) => {
  return Axios.post<any>(ENDPOINTS.orders.create, payload);
};

const updateOrderStatus = (orderId: number, statusId: number, message?: string) => {
  return Axios.patch<any>(ENDPOINTS.orders.orderStatus, {
    entityId: orderId,
    message: message || `Order ${orderId} status updated`,
    statusId,
    orderStatusId: statusId,
  });
};

const updateOrderDetailStatus = (
  orderDetailId: number,
  statusId: number,
  courierId?: number,
  message?: string
) => {
  return Axios.patch<any>(ENDPOINTS.orderDetails.orderDetailStatus, {
    entityId: orderDetailId,
    message: message || `Order detail ${orderDetailId} status updated`,
    statusId,
    courierId,
  });
};

export interface IRefundItem {
  orderDetailId: number;
  quantityRefunded: number;
}

const createRefund = (payload: { orderId: number; reason: string; items: IRefundItem[] }) => {
  return Axios.post<any>(ENDPOINTS.refunds.create, payload);
};

const OrderService = {
  getUserOrders,
  getAllOrders,
  filterOrders,
  getOrderById,
  updateOrderStatus,
  updateOrderDetailStatus,
  createRefund,
  createOrder,
};

export default OrderService;
